<template>
    <v-layout row wrap>
        <v-flex xs12 v-if="cartItems.length > 0">
            <v-expansion-panel :value="itemsPanel">
                <v-expansion-panel-content :readonly="true" :hide-actions="true"
                                           style="background:transparent">
                    <template v-slot:header>
                        <h2 class="primary--text">
                            {{ $vuetify.t('$vuetify.shop.shop_cart') }}
                        </h2>
                    </template>
                    <!--                    -->
                    <!--                    <ItemsListCard v-if="cartHasMenu"-->
                    <!--                                   :items="cartItems">-->
                    <!--                    </ItemsListCard>-->

                    <ItemsList
                            :items="cartItems"
                            :displayEditQuantity=true
                            :displayRemove=true>
                    </ItemsList>
                </v-expansion-panel-content>
            </v-expansion-panel>

            <v-divider class="my-3 grey lighten-2"></v-divider>

            <v-flex offset-sm4 offset-md6 offset-lg8>
                <v-list>
                    <v-list-tile>
                        <v-list-tile-content>
                            <v-list-tile-title>
                                <h4 class="text-xs-right">
                                    {{ cartTotalItems }} {{ $vuetify.t('$vuetify.shop.shop_cart_items')}}
                                </h4>
                            </v-list-tile-title>
                        </v-list-tile-content>
                    </v-list-tile>
                    <v-list-tile>
                        <v-list-tile-content>
                            <v-list-tile-title><h2>{{ $vuetify.t('$vuetify.total') }}</h2></v-list-tile-title>
                        </v-list-tile-content>

                        <v-list-tile-action>
                            <h2>
                                {{ cartTotalAmount }}&nbsp;{{currencySymbol}}
                            </h2>
                        </v-list-tile-action>
                    </v-list-tile>
                </v-list>
            </v-flex>

            <div class="text-xs-center">
                <v-btn
                        @click="submit"
                        class="primary"
                        large
                >
                    {{ $vuetify.t('$vuetify.shop.shop_cart_checkout') }}
                    <v-icon right small>fal fa-angle-double-right</v-icon>
                </v-btn>
            </div>
        </v-flex>

        <v-flex xs12 v-else>
            <v-layout align-center justify-center column>
                <v-spacer class="my-4"></v-spacer>
                <v-icon style="font-size: 150px">fal fa-shopping-cart</v-icon>
                <v-spacer class="my-4"></v-spacer>
                <h2 class="title text-xs-center">{{ $vuetify.t('$vuetify.shop.shop_cart_empty') }}</h2>
                <v-spacer class="my-4"></v-spacer>
                <div class="text-xs-center">
                    <v-btn
                            @click="goTo"
                            class="primary"
                            large
                    >
                        {{ $vuetify.t('$vuetify.shop.buy') }}
                        <v-icon right small>fal fa-angle-double-right</v-icon>
                    </v-btn>
                </div>
            </v-layout>
        </v-flex>

    </v-layout>
</template>


<script>
    import {mapGetters} from 'vuex';
    import ItemsList from '@/components/ItemsList.vue';

    export default {
        name: "ShoppingCart",
        components: {ItemsList},
        data() {
            return {
                customer: {},
                itemsPanel: 0,
            }
        },
        methods: {
            /**
             * The method assigned to the button which allows finishing the Order. This button
             * redirects the user to the interface where the Delivery Options can be chosen.
             **/
            submit() {
                this.$router.push({name: 'order-delivery'})
            },
            /**
             * The method assigned to the button which is displayed once the Shopping Cart is empty. This button
             * redirects the user to the Catalog
             **/
            goTo() {
                this.$router.push({name: "catalog"});
            }
        },
        computed: {
            ...mapGetters({
                cartItems: 'shop/cartItems',
                cartTotalItems: 'shop/cartSize',
                cartTotalAmount: 'shop/cartTotalAmount',
                cartHasMenu: 'shop/cartHasItemMenu',
                currencySymbol: 'configs/currencySymbol'
            })
        }
    }
</script>

<style scoped>
</style>